export const clearDropdowns = () => {
	const dropdowns = document.getElementsByClassName('dropdown open');
	for (let i = 0; i < dropdowns.length; i++) dropdowns[i].className = 'dropdown';
	if (document.getElementsByClassName('dropdown open').length > 0) {
		document.getElementsByClassName('dropdown open')[0].className = 'dropdown';
	}
};
